module.exports = __webpack_public_path__ + "48eaa97ad69bb2c540f8c1de100acd14.pdf";